<script>
  import StartTrendingHeader from '@app-components/post-onboarding/StartTrendingHeader.svelte';
  export let mobile = false;
  let listItems = ['Get on Trending page', 'Get into people’s feeds', 'Get indexed on Google'];
</script>

<style lang="scss">
  .content-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 40px;
    margin-bottom: 70px;
    &.desktop {
      width: 374px;
    }
    &.mobile {
      width: 100%;
    }
  }
  .list-container {
    display: flex;
    width: 100%;
    flex-direction: column;
    align-items: left;
    padding-left: 42px;
    gap: 20px;
    .list-item {
      display: flex;
      align-items: center;
      gap: 20px;
      .checkmark {
        display: flex;
        width: 32px;
        height: 32px;
        padding: 8px;
        justify-content: center;
        align-items: center;
        aspect-ratio: 1/1;
        border-radius: 56px;
        background: #f5f3fc;
      }
      .description {
        color: #717171;
        font-size: 20px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
      }
    }
  }
</style>

<div class="content-container start-trending-step-first {mobile ? 'mobile' : 'desktop'}">
  <StartTrendingHeader mobile={mobile} currentStep={'first'} />
  <div class="list-container">
    {#each listItems as item}
      <div class="list-item">
        <div class="checkmark">
          <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
            <path
              d="M15.4883 4.28479L14.958 4.81409L7.50098 12.2643C6.8177 12.9469 5.71062 12.9469 5.02734 12.2643L2.02246 9.26331L1.49219 8.73303L2.55176 7.67249L3.08301 8.20178L6.08691 11.2037C6.18448 11.3012 6.34281 11.3011 6.44043 11.2037L13.8984 3.75354L14.4287 3.22327L15.4883 4.28479Z"
              fill="#1C1C1C" />
          </svg>
        </div>
        <div class="description">{item}</div>
      </div>
    {/each}
  </div>
</div>
